/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var LightbulbIcon24Solid = forwardRef('LightbulbIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M17.27 14.11c-.73.783-1.307 1.749-1.307 2.819a.012.012 0 0 1-.012.012H12.9V9.388a.9.9 0 1 0-1.8 0v7.553H8.049a.012.012 0 0 1-.012-.012c0-1.075-.578-2.044-1.31-2.831a7.2 7.2 0 1 1 10.542.013Z" }),
        React.createElement("path", { d: "M15.395 19.865H8.617a.9.9 0 1 1 0-1.8h6.778a.9.9 0 0 1 0 1.8Z" }),
        React.createElement("path", { d: "M10.28 21a.9.9 0 1 0 0 1.8h3.44a.9.9 0 0 0 0-1.8h-3.44Z" })));
});
